import type { INonIndexRoute, IRoute } from '@/router/helpers'
import { BasicLayout, MainLayout } from '@/layouts'
import { filterEmptyRoutes, transformRoutes } from '@/router/helpers'
import { AuthWrapper } from '@/router/wrappers'

const baseRoutes: IRoute[] = [
  {
    path: '',
    Component: BasicLayout,
    children: [
      {
        path: '',
        Component: MainLayout,
        children: [
          {
            path: '',
            Component: lazy(() => import('@/views/home')),
            meta: { title: '首页' },
          },
          {
            path: 'callback',
            Component: lazy(() => import('@/views/callback')),
            meta: { title: '首页' },
          },
          {
            path: 'debug',
            Component: lazy(() => import('@/views/callback/debug')),
            meta: { title: '调试' },
          },
          ...Object.values(
            import.meta.glob<INonIndexRoute>('./modules/*.tsx', { import: 'default', eager: true })
          ).flat(),
        ],
      },
      {
        path: '',
        Component: MainLayout,
        wrappers: [AuthWrapper],
        children: Object.values(
          import.meta.glob<INonIndexRoute>('./modules/auth/*.tsx', { import: 'default', eager: true })
        ).flat(),
      },
      {
        path: '403',
        Component: lazy(() => import('@/views/error/403')),
        meta: { title: '没有权限' },
      },
      {
        path: '500',
        Component: lazy(() => import('@/views/error/500')),
        meta: { title: '服务器错误' },
      },
      {
        path: '*',
        Component: lazy(() => import('@/views/error/404')),
        meta: { title: '404' },
      },
    ],
  },
]

const routes = transformRoutes(filterEmptyRoutes(baseRoutes))

export default routes
